import axios from "../utils/axios";

export const getValueSection = async () => {
    const response = await axios.get("/value-section");
    return response.data;
};

export const updateValueSection = async (data) => {
    const response = await axios.put("/value-section", data);
    return response.data;
};
